import { render } from "./support-modal-success.vue?vue&type=template&id=6c032d14&scoped=true&ts=true"
import script from "./support-modal-success.vue?vue&type=script&lang=ts"
export * from "./support-modal-success.vue?vue&type=script&lang=ts"

import "./support-modal-success.vue?vue&type=style&index=0&id=6c032d14&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c032d14"]])

export default __exports__